
import Pagination from "@/components/ui/table/pagination-table";
import { useMemo, useState } from "react";
import { useDeleteEmailTemplatesMutation, useGetEmailTemplatesQuery } from "@/services/systemConfigApi";
import { EmailTemplate } from "@/types/system-setting/system-config";
import useTableData from "@/components/ui/table/data-table-logic";
import usePagination from "@/hooks/use-pagination";
import { DataTableRowActions } from "../../modal/row-actions";
import ReminderTemplatesForm from "../../modal/reminder-template-form";

interface SearchCriteriaType {
    limit: number;
    offset: number;
    sort_order: string;
    sort_key: string;
    type: string;
}

const initialValue = {
    limit: 10,
    offset: 0,
    sort_order: "desc",
    sort_key: "id",
    type: "template",
};
const ReminderTemplate = () => {
    const [action, setAction] = useState<"add" | "edit">("add");
    const [data, setData] = useState<EmailTemplate | undefined>(undefined);
    const [showAddReminder, setShowAddReminder] = useState(false)


    const {
        searchCriteria,
        query,
        toggleSortOrder,
        setSearchCriteria,
        inputValue,
        setInputValue,
    } = useTableData(initialValue);

    const [deleteTemplate] = useDeleteEmailTemplatesMutation()
    const { data: emailTemplatesData } = useGetEmailTemplatesQuery({
        query: query,
        // query: '',
    })


    const totalRecords = emailTemplatesData?.filtered_counts || 0;
    // const totalRecords = 500;

    const {
        handleLimitChange,
        handleNextPage,
        handlePrevPage,
        handleFirstPage,
        handleLastPage,
        isLastPage,
    } = usePagination<SearchCriteriaType>({
        totalRecords,
        searchCriteria,
        setSearchCriteria,
    });

    const emailTemplates = useMemo(() => {
        return Array.isArray(emailTemplatesData?.data) ? emailTemplatesData?.data : [];
        // return Array.isArray(emailTemplatesData) ? emailTemplatesData : [];
    }, [emailTemplatesData]);

    const handleEdit = (data: EmailTemplate) => {
        console.log("Edit notification:", data);
        setAction("edit");
        setData(data);
        setShowAddReminder(true);
        // Add your edit logic here
    };

    const refetch = () => {
        console.log("Refetch notifications");
        // Add your refetch logic here
    };

    const deleteReminderTemplate = async (id: number) => {
        console.log("Deleting notification with ID:", id);
        await deleteTemplate(id).unwrap()
    };
    console.log({ emailTemplates })
    return (

        <div className="space-y-3">
            {emailTemplates.length > 0 && emailTemplates?.map((emailTemplate, i) => (
                <div
                    key={emailTemplate.id}
                    className="border rounded-lg p-4 hover:border-green-500/50 transition-colors"
                >
                    <div className="flex items-start justify-between">
                        <div className="space-y-3 flex-1">
                            <div className="flex items-start justify-between">
                                <div className="flex items-end justify-between ">
                                    <div className="space-y-2">
                                        <div className="flex gap-2">
                                            <span className="text-sm font-medium">Name:</span>
                                            <span className="text-sm text-green-500">
                                                {emailTemplate.name}
                                            </span>
                                        </div>
                                        <div className="flex gap-2">
                                            <span className="text-sm font-medium">Subject:</span>
                                            <span className="text-sm text-muted-foreground">
                                                {emailTemplate.subject}
                                            </span>
                                        </div>
                                    </div>


                                </div>

                                <DataTableRowActions
                                    data={emailTemplate}
                                    refetch={refetch}
                                    handleEdit={() => handleEdit(emailTemplate)}
                                    access="admin" // Pass access level if needed
                                    title="Reminder Template"
                                    deleteAction={() => deleteReminderTemplate(emailTemplate.id as number)} // Pass delete mutation function
                                />
                            </div>
                        </div>
                    </div>


                </div>
            ))}
            {emailTemplates.length > 0 && (
                <Pagination
                    limit={searchCriteria.limit}
                    offset={searchCriteria.offset}
                    totalItems={totalRecords}
                    onLimitChange={handleLimitChange}
                    onNextPage={handleNextPage}
                    onPrevPage={handlePrevPage}
                    onFirstPage={handleFirstPage}
                    onLastPage={handleLastPage}
                    isLastPage={isLastPage}
                />
            )}

            <ReminderTemplatesForm
                isOpen={showAddReminder}
                setOpen={setShowAddReminder}
                action={action}
                setAction={setAction}
                refetch={refetch}
                editModeData={data}
            />
        </div>

    );
};

export default ReminderTemplate;
